import { EvergreenWealthLogo } from '@egw/assets'
import { Button, ButtonVariant, Link, LinkVariant } from '@egw/components'
import { configClient } from '@egw/config'
import { CUSTOMER_SERVICE_PHONE_NUMBER, WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { ArrowLongRightIcon, InformationCircleIcon, LockClosedIcon, ScaleIcon } from '@heroicons/react/24/outline'
import { type FC } from 'react'
import { type Config } from '../../types/config/config'

export const MaintenancePage: FC = () => {
  const { t } = useTranslation('layouts')
  const config = configClient.getConfig() as Config

  return (
    <div className="h-full flex flex-col">
      <div className="px-sm h-2xl sm:h-3xl bg-black items-center gap-sm flex">
        <div className="flex-1">
          <Link href={WEALTH_ROUTES.HOME.path} title={t('header.home_link_title')}>
            <EvergreenWealthLogo className="h-3" />
          </Link>
        </div>
      </div>
      <div className="flex flex-col egw-container pt-5xl">
        <h1 className="typo-primary-6xl-light text-text-header mb-md">{t('maintenance.be_back_soon')}</h1>
        <div className="text-text-body typo-primary-base mb-4xl">{t('maintenance.maintenance_message')}</div>
        <div className="flex flex-col gap-sm">
          <div className="flex flex-row justify-between items-center">
            <h2 className="typo-primary-2xl-light mb-2xs">{t('help_center.help_center_title')}</h2>
            <Link href={config.zendeskArticles.helpCenter}>
              <span className="group-hover:cursor-pointer flex flex-row gap-3xs">
                {t('help_center.visit_help_center')}
                <ArrowLongRightIcon className="group-hover:cursor-pointer h-md w-md cursor-pointer fill-action" />
              </span>
            </Link>
          </div>
          <div className="flex flex-col md:flex-row gap-sm w-full mb-xl">
            <Link href={config.zendeskArticles.helpCenterLegal} variant={LinkVariant.secondary} className="flex-grow">
              <span className="flex flex-row gap-sm md:gap-2xs text-left md:text-center justify-start md:justify-center w-full">
                <ScaleIcon className="w-md h-md" />
                {t('help_center.legal')}
              </span>
            </Link>
            <Link href={config.zendeskArticles.helpCenterPrivacy} variant={LinkVariant.secondary} className="flex-grow">
              <span className="flex flex-row gap-sm md:gap-2xs text-left md:text-center justify-start md:justify-center w-full">
                <LockClosedIcon className="w-md h-md" />
                {t('help_center.privacy')}
              </span>
            </Link>

            <Link variant={LinkVariant.secondary} href={config.zendeskArticles.helpCenterFAQs} className="flex-grow ">
              <span className="flex flex-row gap-sm md:gap-sm text-left md:text-center justify-start md:justify-center w-full">
                <InformationCircleIcon className="w-md h-md" />
                {t('help_center.faqs')}
              </span>
            </Link>
          </div>
          <div className="flex flex-row gap-4xl w-full">
            <div className="typo-primary-base text-text-body justify-between">
              {t('maintenance.contact_client_service')}
            </div>
            <Button
              variant={ButtonVariant.Secondary}
              onClick={() => window.open(`tel:${CUSTOMER_SERVICE_PHONE_NUMBER}`)}
              className="w-fit"
            >
              {t('maintenance.call_us')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
